import React from 'react'
import NavBar from '../components/navbar.js'
import Hero from '../components/hero.js'
import herobg from '../assets/12.jpg'
import '../components/hero.css'

function Home() {
  return (
    <>
    <NavBar/>
    <Hero
    cName = 'hero'
    heroImage = {herobg}
    title='YOUR JOURNEY YOUR STORY'
    text='Choose Your Favorite Destination'
    url='/'
    btnClass='show'
    btnText='Travel Plan'
    />
    </>
  )
}

export default Home